import BaseService from '_services/rest/base';

class TicketService extends BaseService {
  constructor() {
    super();
  }

  deleteFile(id) {
    return this.request(`${this.getUrl()}/comment/file/${id}`, null, 'DELETE')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  removeOption(id, type = 'typeList') {
    const url = (type === 'typeList') ? 'type' : 'color';
    return this.request(`${this.getUrl()}/${url}/${id}`, null, 'DELETE')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  removeType(id) {
    return this.request(`${this.getUrl()}/type/${id}`, null, 'DELETE')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getUrl() {
    return `${super.getUrl()}api/ticket`;
  }

  getUrlSave(id, url = '') {
    if (id) {
      return {
        url: `${this.getUrl()}${url}/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}${url}`,
      method: 'POST',
    };
  }

  getTypes() {
    return this.request(`${this.getUrl()}/type`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getColors() {
    return this.request(`${this.getUrl()}/color`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getList(params) {
    const filters = { search: params.search, project_id: params.project_id || null };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getTicketById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveTicket(ticket) {
    const meta = this.getUrlSave(ticket.id);
    let formData = new FormData();
    formData = this.setFormData(ticket, formData);
    formData = this.setFiles(ticket, formData);
    return this.request(meta.url, formData, meta.method)
      .catch(err => {
        throw err;
      });
  }

  saveType(ticket) {
    const meta = this.getUrlSave(ticket.id, '/type');
    return this.request(meta.url, ticket, meta.method)
      .catch(err => {
        throw err;
      });
  }

  saveOption(color, url = '/type') {
    const meta = this.getUrlSave(color.id, url);
    return this.request(meta.url, color, meta.method)
      .catch(err => {
        throw err;
      });
  }

  saveTicketComment(comment) {
    let formData = new FormData();
    formData = this.setFormData(comment, formData);
    formData = this.setFiles(comment, formData);
    return this.request(`${this.getUrl()}/comment`, formData, 'POST')
      .catch(err => {
        throw err;
      });
  }

  setFiles(object, formData) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < object.files.length; i++) {
      formData.append(`files[${i}]`, object.files[i]);
    }
    return formData;
  }

  updateTicket(ticket) {
    return this.request(`${this.getUrl()}/${ticket.id}`, ticket, 'PATCH')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  setFormData(object) {
    const formData = new FormData();
    Object.entries(object).map(field => (
      formData.append(field[0], field[1])
    ));
    return formData;
  }
}

export default new TicketService();
